var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCvv({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 26,
    viewBox: "0 0 35 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.42,11.8H30.94a.64.64,0,0,1,.67.6v9.78a.65.65,0,0,1-.67.6H11.42a.65.65,0,0,1-.67-.6V12.4A.64.64,0,0,1,11.42,11.8ZM30.27,13H12.08v8.57H30.27Z",
    fill: "#d163ab"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34,1.07A3.39,3.39,0,0,0,31.51,0h-28A3.39,3.39,0,0,0,1,1.07,3.77,3.77,0,0,0,0,3.66V22.34a3.77,3.77,0,0,0,1,2.59A3.39,3.39,0,0,0,3.49,26h28A3.39,3.39,0,0,0,34,24.93a3.77,3.77,0,0,0,1-2.59V3.66A3.77,3.77,0,0,0,34,1.07ZM2.12,2.22a1.87,1.87,0,0,1,1.37-.6h28a1.87,1.87,0,0,1,1.37.6,2,2,0,0,1,.57,1.44v.39H1.55V3.66A2,2,0,0,1,2.12,2.22ZM32.88,23.78a1.87,1.87,0,0,1-1.37.6h-28a1.87,1.87,0,0,1-1.37-.6,2,2,0,0,1-.57-1.44V10.07h31.9V22.34A2,2,0,0,1,32.88,23.78ZM17.37,17.11a1.31,1.31,0,1,1-1.31-1.31A1.31,1.31,0,0,1,17.37,17.11Zm5.29,0a1.31,1.31,0,1,1-1.31-1.31A1.31,1.31,0,0,1,22.66,17.11Zm5.29,0a1.31,1.31,0,1,1-1.31-1.31A1.31,1.31,0,0,1,28,17.11Z",
    fill: "#41319c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvv);
export default __webpack_public_path__ + "static/media/cvv.956746d6a6d847aa1de2e877de9e9b79.svg";
export { ForwardRef as ReactComponent };